<template>
  <div>
    <Loader v-if="loading" text="" color="black" />
    <v-autocomplete
      v-model="countriesSelected"
      :search-input.sync="inputTextCountries"
      :items="availableCountries"
      chips
      small-chips
      deletable-chips
      hide-details
      :label="label"
      multiple
      clearable
      return-object
      item-text="name"
      item-value="id"
      class="autocomplete"
      @change="updateValue"
      v-show="!loading"
    />
  </div>
</template>

<script>
import lodashGet from "lodash/get";
import lodashDebounce from "lodash/debounce";
import lodashOrderBy from "lodash/orderBy";
import lodashFind from "lodash/find";
import lodashUniq from "lodash/uniq";
import lodashIsEqual from "lodash/isEqual";

import { SEARCH_AOIID_MAX_ALLOWED } from "@/common/constants/savedSearch";
import { getAllCountries } from "@/common/maps/utilities";

export default {
  name: "SearchFilterLocations",
  props: {
    value: {
      type: Array,
    },
    reset: {
      type: String,
    },
    label: {
      type: String,
      required: false,
      default: "Countries",
    },
  },
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  data() {
    return {
      enabled: [],
      maxAoiIdAllowed: SEARCH_AOIID_MAX_ALLOWED,
      aoiIdSelected: [],
      countriesSelected: [],
      availableCountries: [],
      transformedRadius: null,
      loading: false,
      inputTextCountries: "",
    };
  },
  async mounted() {
    this.loading = true;
    await this.setUpCountries();
    this.loading = false;
    this.handleChangeAoiIds(this.aoiIdSelected, null);
  },
  methods: {
    async setUpCountries() {
      const items = await getAllCountries();
      let countries = [];
      if (items) {
        const len = items.length;
        for (let i = 0; i < len; i++) {
          const country = items[i];
          if (
            lodashGet(country, "properties.iso2") &&
            lodashGet(country, "properties.displayName")
          ) {
            countries.push({
              id: country.properties.iso2,
              name: country.properties.displayName,
            });
          }
        }
        countries = lodashOrderBy(countries, ["name"], ["asc"]);
      }
      this.availableCountries = countries;
    },
    updateValue() {
      let aoiId = [];
      aoiId = aoiId.concat(this.countriesSelected);
      this.aoiIdSelected = aoiId.map((aoi) => {
        return aoi.id;
      });
      this.emitChange();
    },
    emitChange: lodashDebounce(function () {
      this.$emit("input", this.aoiIdSelected);
    }, 800),
    handleChangeAoiIds(newVal, oldVal) {
      if (!lodashIsEqual(newVal, oldVal)) {
        const countries = [];
        if (Array.isArray(this.value)) {
          this.value.forEach((aoi) => {
            const found = lodashFind(this.availableCountries, ["id", aoi]);
            if (found) {
              countries.push(found);
            }
          });
        }
        this.countriesSelected = countries;

        let aoiId = Array.isArray(this.countriesSelected)
          ? this.countriesSelected.map((aoi) => aoi.id)
          : [];

        this.aoiIdSelected = lodashUniq(aoiId);

        // this bit of code is used to remove the last item added
        // if it is more than the allowed number of aois selected
        if (
          this.aoiIdSelected &&
          this.aoiIdSelected.length > this.maxAoiIdAllowed
        ) {
          this.countriesSelected.splice(-1);
          this.handleAoiChange();
        }
      }
    },
  },
  watch: {
    countriesSelected: {
      handler() {
        this.inputTextCountries = "";
      },
    },
    value: {
      handler(newVal, oldVal) {
        this.handleChangeAoiIds(newVal, oldVal);
      },
      deep: true,
    },
    reset: {
      handler() {
        this.aoiIdSelected = [];
        this.countriesSelected = [];
        this.emitChange();
      },
    },
  },
  beforeDestroy() {
    this.aoiIdSelected = [];
    this.countriesSelected = [];
  },
};
</script>
